<template>
  <div class="page">
    <img src="../../assets/download_bg.jpg" alt="" />
    <span @click="download()">下载特屋兔APP</span>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},

  props: {},

  data() {
    return {}
  },

  filters: {},
  computed: {},
  watch: {},

  created() {
    document.title = '下载特屋兔APP'
  },

  methods: {
    download() {
      const deviceType = this.$utils.getDeviceType()

      if (deviceType.isAndroid) {
        window.location.href = 'https://cloud.lantin.me/pro/app-release.apk'
      } else if (deviceType.isiOS) {
        window.location.href = 'https://apps.apple.com/us/app/%E7%89%B9%E5%B1%8B%E5%85%94/id1620136055'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.page {
  width: 100%;
  // margin-top: 100px;
  // height: 100%;
  position: relative;
  img {
    width: 100%;
  }
  span {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 13.53%;
    width: 614px;
    height: 111px;
    border-radius: 68px;
    border: 2px solid #ffffff;
    font-size: 40px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
    line-height: 111px;
  }
}
</style>
